import IRepository from "./repository";

const GETTER_GET_VISIBLE_FIELDS_FOR_GROUP = 'getVisibleFieldsForGroup';
const GETTER_GET_FIELDS_FOR_REQUEST = 'getFieldsForRequest';
const GETTER_GET_PINS = 'getPins';
const GETTER_IS_SUBMITABLE = 'isSubmitable';

const ACTION_LOAD_STORE = 'loadStore';
const ACTION_SAVE_VALUE = 'saveValue';

export default class FieldsRepository extends IRepository {

    isSubmitable() {
        return this.getters(GETTER_IS_SUBMITABLE);
    }

    getVisibleFieldsForGroup(group_id) {
        return this.getters(GETTER_GET_VISIBLE_FIELDS_FOR_GROUP)(group_id);
    }

    getFieldsForRequest() {
        return this.getters(GETTER_GET_FIELDS_FOR_REQUEST);
    }

    getPins() {
        return this.getters(GETTER_GET_PINS);
    }

    loadStore(form) {
        return this.dispatch(ACTION_LOAD_STORE, form);
    }

    saveValue(fieldId, value) {
        return this.dispatch(ACTION_SAVE_VALUE, {fieldId, value});
    }
}